import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    newRelicHostNameSelector,
    newRelicApplicationIdSelector
} from '../selectors/app-config-selectors';

export class InitNewRelicScript extends Component{
    componentDidMount(){
        if( window.initializeNewRelic ){
            const { hostname, applicationId } = this.props;
            window.initializeNewRelic( hostname, applicationId );
        }
    }

    render(){
        return '';
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        applicationId: newRelicApplicationIdSelector( state ),
        hostname: newRelicHostNameSelector( state ),
    };
};

InitNewRelicScript.propTypes = {
    applicationId: PropTypes.string,
    hostname: PropTypes.string,
};

export default connect( mapStateToProps, {} )( InitNewRelicScript );
